import { Activity, FileSearch, Pill, Cpu, Users, Building2, Heart, Droplet, Syringe, UsersRound, Stethoscope, Zap, Wind, Thermometer, Scale, Brain as BrainIcon, Bone, Activity as PulseIcon } from 'lucide-react';
import { Stethoscope as StethoscopeIcon, Brain, HeartPulse } from 'lucide-react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

export const CLINIC_HIGHLIGHTS = [
  {
    icon: StethoscopeIcon,
    titleKey: 'precision',
    descKey: 'precisionDesc',
    title: 'Precision Medicine',
    description: 'Expert evaluation with modern diagnostics'
  },
  {
    icon: Brain,
    titleKey: 'techDriven',
    descKey: 'techDrivenDesc',
    title: 'Tech-Driven Care',
    description: 'AI-enhanced clinical decision making'
  },
  {
    icon: HeartPulse,
    titleKey: 'continuity',
    descKey: 'continuityDesc',
    title: 'Continuity of Care',
    description: 'Seamless referrals to tertiary facilities'
  }
];

export const CLINICAL_SERVICES = [
  {
    icon: Droplet,
    titleKey: 'diabetes',
    descKey: 'diabetesDesc',
    title: 'Diabetes Management & Diabetes Clinic',
    description: 'Expert diabetologist in Chandrapur offering comprehensive diabetes care for Type 1, Type 2, and gestational diabetes. Expert in blood sugar control, HbA1c management, insulin therapy, and advanced treatments including Mounjaro (Tirzepatide) and Ozempic (Semaglutide) when required. Complete diabetes clinic with personalized treatment plans.'
  },
  {
    icon: Heart,
    titleKey: 'hypertension',
    descKey: 'hypertensionDesc',
    title: 'Hypertension & High BP Treatment',
    description: 'Expert BP doctor in Chandrapur for advanced blood pressure management. Expert treatment of hypertension to prevent heart disease, stroke, kidney complications, and cardiac events. Comprehensive cardiovascular risk assessment and long-term BP control strategies.'
  },
  {
    icon: Syringe,
    titleKey: 'thyroid',
    descKey: 'thyroidDesc',
    title: 'Thyroid Disorders',
    description: 'Expert thyroid specialist in Chandrapur and Vidarbha. Expert diagnosis and treatment of hypothyroidism, hyperthyroidism, thyroid nodules, goiter, and all thyroid-related conditions. Comprehensive thyroid function monitoring and hormone management.'
  },
  {
    icon: HeartPulse,
    titleKey: 'cardiac',
    descKey: 'cardiacDesc',
    title: 'Cardiac Evaluation & Heart Health',
    description: 'Expert heart specialist in Chandrapur for cardiac evaluation, ECG monitoring, chest pain assessment, cholesterol management, cardio-metabolic care, and heart disease prevention. Expert cardiac risk stratification and management.'
  },
  {
    icon: Wind,
    titleKey: 'respiratory',
    descKey: 'respiratoryDesc',
    title: 'Respiratory & Chest Diseases',
    description: 'Expert pulmonologist in Chandrapur for Asthma, COPD, chronic cough, breathlessness, post-COVID lung care, pleural effusion, and all respiratory conditions. Nebulization, spirometry, and comprehensive lung disease management available.'
  },
  {
    icon: Bone,
    titleKey: 'rheumatology',
    descKey: 'rheumatologyDesc',
    title: 'Rheumatology & Arthritis Care',
    description: 'Expert arthritis doctor in Chandrapur for Rheumatoid Arthritis, Osteoarthritis, Osteoporosis, Gout, joint pain, SLE (Lupus), and autoimmune disorders. Comprehensive rheumatology care and pain management.'
  },
  {
    icon: Thermometer,
    titleKey: 'fever',
    descKey: 'feverDesc',
    title: 'Fever & Infectious Diseases',
    description: 'Expert fever doctor in Chandrapur for treatment of viral fevers, Dengue, Malaria, Typhoid, COVID-19, and other acute infectious diseases. Expert in managing acute illnesses and infectious disease complications.'
  },
  {
    icon: Scale,
    titleKey: 'weightLoss',
    descKey: 'weightLossDesc',
    title: 'Weight Loss & Obesity Management',
    description: 'Expert weight loss doctor in Chandrapur offering medical weight management, obesity treatment, lifestyle modification, metabolic syndrome care, and preventive health programs. Expert guidance for sustainable weight loss.'
  },
  {
    icon: PulseIcon,
    titleKey: 'stroke',
    descKey: 'strokeDesc',
    title: 'Stroke Care & Neurological Emergencies',
    description: 'Expert stroke doctor in Chandrapur for acute stroke management, stroke prevention, neurological emergency stabilization, and higher center referrals. Expert in identifying stroke symptoms and immediate care.'
  },
  {
    icon: Activity,
    titleKey: 'preventive',
    descKey: 'preventiveDesc',
    title: 'Preventive Health & Lifestyle Medicine',
    description: 'Comprehensive preventive health checkups, adult vaccinations, health screenings, lifestyle counseling, and chronic disease prevention. Leading clinic in Chandrapur for preventive healthcare and wellness programs.'
  },
  {
    icon: Stethoscope,
    titleKey: 'emergency',
    descKey: 'emergencyDesc',
    title: 'Emergency & Critical Care',
    description: 'Expert emergency doctor in Chandrapur offering emergency stabilization, nebulization, ECG monitoring, minor emergency procedures, critical care, and seamless higher center referrals for complex cases.'
  },
  {
    icon: UsersRound,
    titleKey: 'family',
    descKey: 'familyDesc',
    title: 'Family Medicine & General Practice',
    description: 'Expert family doctor in Chandrapur for routine checkups, preventive care, chronic disease management, and treatment of common illnesses for all age groups. Trusted family physician in Vidarbha region.'
  }
];

export const CONTACT_INFO = [
  {
    icon: MapPin,
    labelKey: 'address',
    valueKey: 'addressValue',
    label: 'Address',
    value: 'Manohar Tower, Chandrapur - Durgapur Rd, near Matoshri Vidyalaya, Tukum, Chandrapur, Maharashtra 442401',
    link: 'https://maps.app.goo.gl/PQBscVJ99YqincJc8'
  },
  {
    icon: Phone,
    labelKey: 'phone',
    valueKey: 'phoneValue',
    label: 'Phone',
    value: '+91-9552374093, 07172-456926, +91-8668441849',
    link: 'tel:+919552374093'
  },
  {
    icon: Mail,
    labelKey: 'email',
    valueKey: 'emailValue',
    label: 'Email',
    value: 'tongehealthcare@gmail.com',
    link: 'mailto:tongehealthcare@gmail.com'
  },
  {
    icon: Clock,
    labelKey: 'hours',
    valueKey: 'hoursValue',
    label: 'Consultation Hours',
    value: 'Monday - Saturday: 12:00 PM - 4:00 PM & 6:30 PM - 9:00 PM',
    link: null
  }
];

export const CLINIC_INFO = {
  name: 'Tonge Healthcare',
  tagline: 'Evidence-Based. Patient-Centered.',
  subheading: 'Advanced Internal Medicine',
  phone: '+91-9552374093',
  phoneFormatted: '919552374093',
  email: 'tongehealthcare@gmail.com',
  address: 'Manohar Tower, Chandrapur - Durgapur Rd, near Matoshri Vidyalaya, Tukum, Chandrapur, Maharashtra 442401',
  googleMapsUrl: 'https://maps.app.goo.gl/PQBscVJ99YqincJc8'
};
